/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useMemo } from "react";
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";
import { Link } from "react-router-dom";
import ProfileTab from "./EmployeeProfileTab";
import Breadcrumbs from "components/Breadcrumbs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getEmployeeDetailApi } from "api/services/employee";
import { getEmployeeSalaryDetailApi, getAddressApi } from "api/services/employee"
import { useEmployee } from "./../context/employeeContext";
import {renderEventStatus, toTitleCase} from "utils/common"
import Image from "components/Image"
import { formatDateHandler2 } from "utils/common";
import FilterSelect from "components/Form/filterSelect";
import {  useSelector } from 'react-redux';
import ChangePictureModal from "components/modelpopup/EmployeePictureModal"
import { SkeltonLoader } from "components/skeltonLoader";

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  // Add this to extract the profile parameter from the URL
  const searchParams = new URLSearchParams(location.search);
  const isProfileView = searchParams.get('profile') === 'true';

  const {
    userData : userDataList, 
    userDataLoading,
} = useSelector((state) => state.common);
const {
  user,
  userLoading
} = useSelector((state) => state.user);
  const {
    loading,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleEmployeeDetailPage,
    selectedPage,
  } = useEmployee();
  const [userDataOption, setUserDataOption] = useState([]);

  const [userData, setUserData] = useState({});
  const [userSalaryData, setUserSalaryData] = useState({});
  const [pictureModal, setPictureModal] = useState(false);
  const [detailLoading, setDetailLoading] = useState(true);

  const [addresses, setAddresses] = useState([]);
  const [addressLoading, setAddressLoading] = useState(true);



  useEffect(()=>{
   
    let _userData = userDataList?.map(item => {
      return {
        label: ` ${item.emp_no} - ${item.first_name} ${item.middle_name||""} ${item.last_name}`,

          value: item.id
      };
  });
  

    setUserDataOption(_userData)  

},[userDataList])




  // ✅ Fetch addresses from API
  const fetchAddresses = async () => {
    setAddressLoading(true);
    try {
      const response = await getAddressApi({company_user: params?.id});
      setAddresses(response.data?.results); // ✅ Update state with API response
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setAddressLoading(false);
    }
  };

  const fetchDetail = () => {
    setDetailLoading(true);
    getEmployeeDetailApi(params?.id).then((response) => {
      console.log(response, "REEEEEEE");
      setUserData(response.data);
      setDetailLoading(false);
    }).catch(error => {
      console.error("Error fetching employee details:", error);
      setDetailLoading(false);
    });
  }

  useEffect(() => {
    console.log(location, navigate, params, "LLL");
    if (params?.id) {
      fetchDetail()

      getEmployeeSalaryDetailApi(params?.id).then((response) => {
        console.log(response, "SALARY DATAAAAAA");
        setUserSalaryData(response.data)
      })
    }
    fetchAddresses();

  }, [params?.id]);
  
  const handleClickGoBack = () => {
    navigate(-1);
  };

  const handleClickNext = () => {
    const nextIndex = getIndex + 1;
    if (nextIndex < pageSettings.total) {
      let nextEmployee = userDataOption[nextIndex];
      handleEmployeeDetailPage(nextEmployee.value, nextIndex);
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = getIndex - 1;
    if (prevIndex >= 0) {
      let nextEmployee = userDataOption[prevIndex];
      handleEmployeeDetailPage(nextEmployee.value, prevIndex);
    }
  };

  const changeImage = (image) => {
    let _user = {...userData}
    _user['profile_image'] = image
    setUserData(_user)
  }

  const getIndex = useMemo(()=>{

    const index = userDataOption.findIndex(user => user.value === userData.id);
    return index
    
  },[userData])


  const showReportTo = useMemo(()=>{
    const selected = userData?.employment?.report_to?.id
    const is_access = userDataOption.find(user=> user.value === selected)
    if(is_access){

      return (
        <Link
        to={`/employees/${userData?.employment?.report_to?.id}`}
      >
        {userData?.employment?.report_to?.first_name}{" "}
        {userData?.employment?.report_to?.last_name}
      </Link>
      )
    }
    return(
      <p>
      {userData?.employment?.report_to?.first_name}{" "}
      {userData?.employment?.report_to?.last_name}
    </p>
    )
  },[userData, userDataList])
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          
          {/* Only show breadcrumbs if not in profile view */}
          {!isProfileView && (
            <Breadcrumbs
              maintitle="Profile"
              title="Employee"
              subtitle="Profile Detail"
              modal="#add_indicator"
              name="Add New"
              showModal={false}
              linkName="/employees"
            />
          )}

          {/* Only show search user if not in profile view */}
          {!isProfileView && (
            <div>
              <div className="col-md-3 mb-2">
                <FilterSelect 
                  placeholder={"Search user"} 
                  options={userDataOption} 
                  loading={userDataLoading}
                  onChange={e => {
                    console.log(e, "EE")
                    navigate(`/employees/${e.value}`)
                  }} 
                  optionLabel={"label"} 
                  optionValue={'value'}
                />
              </div>
            </div>
          )}

          <div>
            <div className="contact-head">
              <div className="row align-items-center">
                <div className="col-sm-6">
                  {/* Only show back navigation if not in profile view */}
                  {!isProfileView && (
                    <ul className="contact-breadcrumb">
                      <li>
                        <Link to="#" onClick={handleClickGoBack}>
                          <i className="las la-arrow-left" /> Employee
                        </Link>
                      </li>
                      <li>
                        {userData?.first_name} {userData?.last_name}
                      </li>
                    </ul>
                  )}
                </div>
                <div className="col-sm-6 text-sm-end">
                  {/* Only show pagination controls if not in profile view */}
                  {!isProfileView && (
                    <div className="contact-pagination">
                      <p>
                        {getIndex+1} of {pageSettings.total}
                      </p>
                      <ul>
                        <li>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleClickPrevious();
                            }}
                          >
                            <i className="las la-arrow-left" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleClickNext();
                            }}
                          >
                            <i className="las la-arrow-right" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  {detailLoading ? (
                    <div className="profile-view">
                      <div className="profile-img-wrap">
                        <div className="profile-img">
                          <SkeltonLoader number={1} active={true} style={{ width: 100, height: 100, borderRadius: '50%' }} />
                        </div>
                      </div>
                      <div className="profile-basic">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="profile-info-left height-100">
                              <SkeltonLoader number={1} active={true} className="mb-3" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <ul className="personal-info">
                              <SkeltonLoader number={1} active={true} className="mb-3" />
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="profile-view">
                      <div className="profile-img-wrap">
                        <div className="profile-img">
                          {user?.id == userData.id &&
                            <Link
                              to="#"
                              onClick={() => setPictureModal(true)}
                              className="d-flex justify-content-center align-items-center text-white"
                              style={{
                                borderRadius: "50%",
                                position: "absolute",
                                width: 25,
                                height: 25,
                                right: 0,
                                background: "grey"
                              }}
                            >
                              <i className="fa fa-pencil" />
                            </Link>
                          }
                          <Link to="#">
                            <Image src={userData?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                          </Link>
                        </div>
                      </div>
                      <div className="profile-basic">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="profile-info-left height-100">
                              <h3 className="user-name m-t-0 mb-0">
                                {userData?.first_name} {userData?.middle_name} {userData?.last_name}
                              </h3>
                              <h6 className="text-muted">
                                Position: {userData?.employment?.position?.name}
                              </h6>
                              <small className="text-muted">
                                Department: {userData?.employment?.department?.name}
                              </small>
                              <div className="small text-muted">
                                HR Code: {userData?.emp_no}
                              </div>
                              <div className="small text-muted">
                                Date of Join: {formatDateHandler2(userData?.employment?.employment_date)}
                                {renderEventStatus(userData?.employment?.employment_date, "🎉", "", "bg-success")}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <ul className="personal-info">
                              <li>
                                <div className="title">Phone:</div>
                                <div className="text">
                                  <Link
                                    to={`tel:${userData?.company_phone_number}`}
                                  >
                                    {userData?.company_phone_number}
                                  </Link>
                                </div>
                              </li>
                              <li>
                                <div className="title">Email:</div>
                                <div className="text">
                                  <Link to={`mailto:${userData?.company_email}`}>
                                    {userData?.company_email}
                                  </Link>
                                </div>
                              </li>
                              <li>
                                <div className="title">Birthday:</div>
                                <div className="text">{formatDateHandler2(userData?.birthday)}
                                { renderEventStatus(userData?.birthday, "🎂", "Upcoming", "bg-warning" )}
                                
                               

                                </div>
                              </li>
                              <li>
                                <div className="title">Gender:</div>
                                <div className="text">{toTitleCase(userData?.gender||"")}</div>
                              </li>
                              <li>
                                <div className="title">Reports To:</div>
                                <div className="text">
                                  <div className="avatar-box">
                                    <div className="avatar avatar-xs">
                                    <Image  src={userData?.employment?.report_to?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                                    </div>
                                  </div>
                                  {showReportTo}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="pro-edit">
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Show skeleton for tabs when loading */}
          {detailLoading ? (
            <div className="card tab-box">
              <div className="row user-tabs">
                <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                  <SkeltonLoader number={1} active={true} style={{ height: 40 }} />
                </div>
              </div>
            </div>
          ) : (
            <div className="card tab-box">
              <div className="row user-tabs">
                <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                  <ul className="nav nav-tabs nav-tabs-bottom">
                    <li className="nav-item">
                      <Link
                        to="#emp_profile"
                        data-bs-toggle="tab"
                        className="nav-link active"
                      >
                        Profile
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#emp_projects"
                        data-bs-toggle="tab"
                        className="nav-link"
                      >
                        Employment
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#emp_assets"
                        data-bs-toggle="tab"
                        className="nav-link"
                      >
                        Assets
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#emp_leaves"
                        data-bs-toggle="tab"
                        className="nav-link"
                      >
                        Leave
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#emp_documents"
                        data-bs-toggle="tab"
                        className="nav-link"
                      >
                        Documents
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#emp_expenses"
                        data-bs-toggle="tab"
                        className="nav-link"
                      >
                        Expenses
                      </Link>
                    </li>
                    {
                      user?.id == userData?.id &&
                      <li className="nav-item">
                      <Link
                        to="#account_settings"
                        data-bs-toggle="tab"
                        className="nav-link"
                      >
                        Account  Settings
                      </Link>
                      </li>
                    }
                    
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* Show profile tab component only when not loading */}
          {!detailLoading && (
            <ProfileTab
              fetchAddresses={fetchAddresses}
              userData={userData}
              userSalaryData={userSalaryData}
              addressData={addresses}
              addressLoading={addressLoading}
              fetchDetail={fetchDetail}
            />
          )}

          <ChangePictureModal
            show={pictureModal}
            handleClose={() => setPictureModal(false)}
            currentImage={userData?.profile_image}
            id={userData?.id}
            changeImage={changeImage}
          />
        </div>
      </div>
    </>
  );
};

export default Profile;
